<script>
export default {};
</script>

<template>
  <!--START SERVICES-->
  <section class="section pt-5" id="services">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <h1 class="section-title text-center">Por que contratar?</h1>
          <div class="section-title-border margin-t-20"></div>
          <p
            class="section-subtitle text-muted text-center padding-t-30 font-secondary"
          >Veja abaixo algumas razões de porque nós somos o serviço de IPTV que se destaca entre os demais.</p>
        </div>
      </div>

      <div class="row margin-t-30">
        <div class="col-lg-4 margin-t-20">
          <div class="services-box text-center hover-effect">
            <img src="/icons/trofeu.svg" class="icone" />
            <h4 class="padding-t-15">Zero Travamentos</h4>
            <p
              class="padding-t-15 text-muted"
            >Nossa estrutura é dedicada e estável para garantir a melhor performance dos canais, vídeos e séries do nosso catálogo.</p>
          </div>
        </div>

        <div class="col-lg-4 margin-t-20">
          <div class="services-box text-center hover-effect">
            <img src="/icons/suporte.svg" class="icone" />
            <h4 class="padding-t-15">Suporte Dedicado</h4>
            <p
              class="padding-t-15 text-muted"
            >Temos uma equipe treinada e pronta pra ajudar você no que você precisar, o mais rápido possível. </p>
          </div>
        </div>

        <div class="col-lg-4 margin-t-20">
          <div class="services-box text-center hover-effect">
            <img src="/icons/catalogo.svg" class="icone" />
            <h4 class="padding-t-15">Catálogo + completo</h4>
            <p
              class="padding-t-15 text-muted"
            >Temos um catálogo que constantemente é atualizado, sempre cheio de novidades.</p>
          </div>
        </div>

      </div>
      <div class="row margin-t-30">
        <div class="col-lg-4 margin-t-20">
          <div class="services-box text-center hover-effect">
            <img src="/icons/tv.svg" class="icone" />
            <h4 class="padding-t-15">+ de 1.100 canais</h4>
            <p
              class="padding-t-15 text-muted"
            >São canais nacionais e internacionais, incluindo também os privados (como Premieres e Realitys Shows)</p>
          </div>
        </div>
        <div class="col-lg-4 margin-t-20">
          <div class="services-box text-center hover-effect">
            <img src="/icons/filmes.svg" class="icone" />
            <h4 class="padding-t-15">+ de 3.000 conteúdos filmes</h4>
            <p
              class="padding-t-15 text-muted"
            >Desde os clássicos aos lançamentos, nosso catálogo é super completo.</p>
          </div>
        </div>
        <div class="col-lg-4 margin-t-20">
          <div class="services-box text-center hover-effect">
            <img src="/icons/series.svg" class="icone" />
            <h4 class="padding-t-15">+ de 13.000 conteúdos séries</h4>
            <p
              class="padding-t-15 text-muted"
            >Antes mesmo das séries irem para o OnDemand, já disponilizamos no nosso catálogo para nossos clientes.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--START SERVICES-->
</template>

<style scoped>
.icone {
  width: 60px;
  height: 60px;
}
</style>